<template>
  <div>
    <map-text
      v-if="!myselfViewing && isAuth"
      :user-name="profile_visited.name"
      :distance="distance"
    ></map-text>
    <distance-map
      class="pt-1"
      :my_profile="my_profile"
      v-model="mapData"
      :other_profile="profile_visited"
    ></distance-map>
  </div>
</template>

<script lang="babel">
import MapText from '@/components/Customer/profile/MapText';
import DistanceMap from '@/components/Customer/DistanceMap';

export default {
    components: {
      MapText,
      DistanceMap
    },
    data () {
      return {
        mapData: null,
      };
    },
    props: {
      profile_visited: {
        required: true,
        type: Object
      },
      my_profile: {
        required: true,
        validator: prop => typeof prop === 'object' || prop === null
      }
    },
    computed: {
      isAuth() {
        return this.$store.getters["user/auth"];
      },
      distance() {
         if(this.mapData)
            return this.mapData.distance;
      },
      myselfViewing() {
        if (!this.my_profile) {
          return false;
        }

        return this.my_profile.id === this.profile_visited.id;
      }
    }
  };
</script>
